import React, { useState, useEffect } from 'react';

export default function AuditLogs({ token }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`https://hospital-clinic.harrydenny2712.workers.dev/api/audit-logs`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
    .then(res => {
      if (!res.ok) throw new Error('Failed to fetch logs');
      return res.json();
    })
    .then(data => {
      setLogs(data);
      setLoading(false);
    })
    .catch(err => {
      setError(err.message);
      setLoading(false);
    });
  }, [token]);

  if (loading) return <div className="page-content">Loading audit logs...</div>;
  if (error) return <div className="page-content">Error: {error}</div>;

  return (
    <div className="admin-management-container animate-fade">
      <div className="section-header">
        <h2>Security Audit Logs</h2>
        <p>Monitor all administrative actions</p>
      </div>
      
      <div className="admin-list-card glass-card">
        <div className="table-responsive">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Action</th>
                <th>User</th>
                <th>Details</th>
                <th>IP Address</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(log => (
                <tr key={log.id}>
                  <td>{new Date(log.timestamp).toLocaleString()}</td>
                  <td><span className="role-badge">{log.action}</span></td>
                  <td>{log.username}</td>
                  <td>{log.details}</td>
                  <td>{log.ipAddress}</td>
                </tr>
              ))}
              {logs.length === 0 && (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>No audit logs found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
